import moment from 'jalali-moment';
import {useState} from 'react';
import styles from './commentItem.module.scss';
import AddAnswerComment from '../addAnswer';

import Answer from '../../../dashboard/product/store/components/comments/components/answer';

type TCommentItemProps = {
  comment: IComment;
};

const CommentItem = ({comment}: TCommentItemProps) => {
  const [showAnswer, setShowAnswer] = useState<boolean>(false);
  return (
    <>
      <div className={styles['comment']}>
        <div className="d-flex justify-content-between color-gray-2">
          <span>{comment.name}</span>
          <span>{moment(comment.created_at).format('jYYYY/jMM/jDD')}</span>
        </div>
        <div className="pt-3">
          <span className="color-gray-2">نظر درباره محصول : </span>
          <span className="color-gray-1">{comment.post_title} </span>
        </div>
        <div className="pt-3">
          <p className="color-gray-1 lh-lg text-justify">{comment.comment}</p>
        </div>
        <div className="d-flex justify-content-between">
          <span>
            {comment.rate}
            <i className="icon-Star color-gold-custom ps-1"></i>
          </span>
          {!comment?.answer && (
            <span className="color-primary" onClick={() => setShowAnswer(true)}>
              پاسخ به نظر
            </span>
          )}
        </div>
        {comment?.answer && (
          <div className="pt-3">
            <Answer answer={comment?.answer?.answer} />
          </div>
        )}
        {showAnswer && (
          <AddAnswerComment
            setShowAnswer={setShowAnswer}
            commentId={comment.guid}
          />
        )}
      </div>
    </>
  );
};

export default CommentItem;
